module.exports =[
["0xb31bc392cb79e2edd578c02561d0a252d73b6322",3],
["0xb31bc392cb79e2edd578c02561d0a252d73b6323",3]
];